/* unplugin-vue-components disabled */import { render } from "./DynaQueryForm.vue?vue&type=template&id=53445056&scoped=true"
import script from "./DynaQueryForm.vue?vue&type=script&lang=js"
export * from "./DynaQueryForm.vue?vue&type=script&lang=js"

import "./DynaQueryForm.vue?vue&type=style&index=0&id=53445056&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53445056"]])

export default __exports__